import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { DragDropContext } from "react-beautiful-dnd";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { getBoardById } from "../redux/actions/boards";
import { deleteTask, handleSortTasks } from "../redux/actions/tasks";
import Navigation from "../partials/Navigation";
import Column from "../partials/Column";
import CurrentSituation from "../partials/Forms/CurrentSituation";
import IdeaBank from "../partials/Forms/IdeaBank";
import ActionPlan from "../partials/Forms/ActionPlan";
import Implementation from "../partials/Forms/Implementation";
import Evaluation from "../partials/Forms/Evaluation";
import configVars from "../config";
import ConfirmationBox from "../partials/ConfirmationBox";
import { getExpiry } from "../common";
import { Button } from "react-bootstrap";
import { SET_SINGLE_BOARD_FROM_STORE } from "../redux/types";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Purpose from "../partials/Purpose";
import { getNotesFromApi } from "../redux/actions/board-notes";
import BoardNotes from "../partials/BoardNotes";
import useExitPrompt from "../utils/useExitPrompt";
import BoardGuide from "../partials/Boards/BoardGuide";
import BoardNav from "../partials/Boards/BoardNav";
import { RouterPrompt } from "../partials/RouterPrompt";
import { useHistory } from "react-router-dom";
import BoardSettings from "../partials/Boards/BoardSettings";
import BoardChart from "../partials/Boards/BoardChart";

const Task = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [columnsData, setColumnsData] = useState({});
  const [droppableColumn, setDroppableColumn] = useState(null);
  const [draggableColumn, setDraggableColumn] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [show, setShow] = useState(true);
  const [showOnUrl, setShowOnUrl] = useState(false);
  const board = useSelector((state) => state.boards.singleBoard);
  const prev_boardId = useSelector((state) => state.boards.prev_boardId);
  const allBoardsDetails = useSelector(
    (state) => state.boards.allBoardsDetails
  );
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showCloseConfirmationOnTask, setCloseConfirmationOnTask] =
    useState(false);
  // const [boardGuides, setBoardGuides] = useState({});
  const [userId, setUserId] = useState(null);
  const [userJwt, setUserJwt] = useState(null);
  const [cookies] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
  ]);

  const history = useHistory();
  const apiRef = useRef(false);

  const [translation] = useTranslation("translations");

  // const [isBlocking, setIsBlocking] = useState(false);
  const [showExitPrompt, setShowExitPrompt] = useExitPrompt(false);

  const [boardView, setBoardView] = useState("board");

  const _handlefaileddUrl = useCallback(() => {
    props.history.replace({
      pathname: `/`,
    });
  }, [props.history]);

  const get_task_detail = useCallback(
    async (task_id, board_id, userJwt) => {
      try {
        const response = await fetch(
          `${configVars.apiUrl}sustainchange/v1/get-task-detail/?token=${userJwt}`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${configVars.auth}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              task_id: task_id,
              board_id: board_id,
            }),
          }
        );
        const task = await response.json();
        if (task.status_code === 200) {
          let get_task = task?.data;
          setSelectedTask(get_task.data);
          board.associated_users = get_task.associated_users;
          setApiLoading(false);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log({ error });
        return { error: error };
      }
    },
    [board]
  );

  useEffect(() => {
    if (board) {
      setColumnsData({ ...board });
      if (params?.task_id) {
        Object.keys(board?.columns).every((val) => {
          const foundTask = board?.columns[val].tasks[params?.task_id];
          if (foundTask) {
            // console.log("value", val);
            if (!apiRef.current) {
              setApiLoading(true);
              get_task_detail(
                params?.task_id,
                params?.board_id,
                cookies.sustainyou_user_jwt
              );
              setSelectedColumn(val);
              setShowOnUrl(true);
              apiRef.current = true;
            }
          }
          return true;
        });
      }

      if (params?.board_view) {
        setBoardView(params?.board_view);
      } else {
        setBoardView("board");
      }
    }
  }, [board, params, get_task_detail, cookies.sustainyou_user_jwt]);

  async function getSingleBoardById(id, userJwt) {
    try {
      setLoading(true);

      await dispatch(getBoardById(id, userJwt, _handlefaileddUrl));
      await dispatch(getNotesFromApi(id));
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }
  }
  useEffect(() => {
    let expired = getExpiry(
      `sustainchange_single_board_expiry_${params.board_id}`
    );

    async function getSingleBoard(id, user_jwt) {
      try {
        setLoading(true);

        await dispatch(getBoardById(id, user_jwt, _handlefaileddUrl));
        setLoading(false);
      } catch (error) {
        console.log({ error });
        setLoading(false);
      }
    }

    if (cookies.sustainyou_user_jwt) {
      const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
      setUserId(jwtDecoded.id);
      if (userJwt) {
        getConfigs(userJwt);
      }
      if (cookies.sustainyou_user_jwt) {
        setUserJwt(cookies.sustainyou_user_jwt);
      }
      if (
        cookies.sustainyou_user_jwt &&
        (!allBoardsDetails[params.board_id] || expired)
      ) {
        getSingleBoard(params.board_id, cookies.sustainyou_user_jwt);
      } else if (allBoardsDetails[params.board_id]) {
        dispatch({
          type: SET_SINGLE_BOARD_FROM_STORE,
          payload: allBoardsDetails[params.board_id],
        });
      }
    }
  }, [
    params.board_id,
    prev_boardId,
    dispatch,
    cookies,
    allBoardsDetails,
    _handlefaileddUrl,
    userJwt,
  ]);

  const getConfigs = async (userJwt) => {
    try {
      let response = await fetch(
        `${configVars.apiUrl}sustainchange/v1/getconfigurations/?token=${userJwt}`,
        {
          method: "GET",
          headers: {
            Authorization: `Basic ${configVars.auth}`,
            "Content-Type": "application/json",
          },
        }
      );
      const _configs = await response.json();
      setConfig(_configs?.data);
    } catch (error) {
      console.log({ error });
    }
  };
  const closeEditTask = () => {
    setDroppableColumn(null);
    //setIsBlocking(false);
    setShowExitPrompt(false);
    setShow(false);
    setShowOnUrl(false);
    props.history.replace({
      pathname: `/board/${params.board_id}`,
    });
  };

  // const handleClosePrompt = () => {
  //   closeEditTask();
  // };
  const handleClose = (close = false) => {
    // if (isBlocking && !close) {
    //   // console.log("is blocking from handle close", isBlocking);
    //   // if (window.confirm(translation("form_close_confirmation")) === true) {
    //   //   var delayInMilliseconds = 100;
    //   //   setTimeout(function () {
    //   //     closeEditTask();
    //   //   }, delayInMilliseconds);
    //   //   console.log("is blocking from handle close 2", isBlocking);
    //   // } else {
    //   //   return false;
    //   // }
    //   setShowExitPrompt(false);
    // } else {
    closeEditTask();
    // }
  };
  const handleConfirmClose = () => {
    setSelectedTask(null);
    setDroppableColumn(null);
    setDraggableColumn(null);
    setSelectedColumn(null);
    setShow(false);
    setShowOnUrl(false);
    setCloseConfirmationOnTask(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const handleDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    if (source?.droppableId === destination?.droppableId) {
      const column = columnsData.columns[source.droppableId];
      const newTaskIds = Array.from(column.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...column,
        taskIds: newTaskIds,
      };

      const newState = {
        ...columnsData,
        columns: {
          ...columnsData.columns,
          [newColumn.id]: newColumn,
        },
      };
      let tasksArray = [...newTaskIds, ...column.archived];

      handleSort(source?.droppableId, tasksArray, { ...newState });
      setColumnsData({ ...newState });
    } else {
      let _selectedTask =
        columnsData.columns[source.droppableId].tasks[draggableId];
      let _selectedColumn = destination.droppableId;

      setDroppableColumn(_selectedColumn);
      setDraggableColumn(source.droppableId);
      setSelectedTask(_selectedTask);

      handleShow();
    }
  };
  const handleDelete = (e) => {
    handleShowConfirmation();
  };

  const getColumnNo = (id) => {
    let _index = columnsData?.columnOrder?.findIndex(
      (item) => parseInt(item.id) === parseInt(id)
    );
    let columnName = null;
    if (_index > -1) {
      columnName = columnsData.columnOrder[_index].tasklist_title;
    }
    return { columnNo: _index, columnName: columnName };
  };
  const addTaskForm = () => {
    let _index;
    if (droppableColumn) {
      _index = columnsData?.columnOrder?.findIndex(
        (item) => parseInt(item.id) === parseInt(droppableColumn)
      );
    } else {
      _index = columnsData?.columnOrder?.findIndex(
        (item) => parseInt(item.id) === parseInt(selectedColumn)
      );
    }

    switch (_index) {
      case 0:
        return (
          <CurrentSituation
            setApiLoading={apiLoading}
            show={show || showOnUrl}
            selectedTask={selectedTask}
            handleClose={handleClose}
            selectedColumn={selectedColumn}
            droppableColumn={droppableColumn}
            draggableColumn={draggableColumn}
            board={board}
            updateTask={updateTask}
            handleArchive={handleArchive}
            handleUnarchive={handleUnarchive}
            addTask={addTask}
            config={config}
            handleDelete={handleDelete}
            getColumnNo={getColumnNo}
            columnTitle={
              columnsData?.columnOrder &&
              columnsData?.columnOrder[_index].tasklist_title
            }
            setShowCloseConfirmation={(val) => {
              //setIsBlocking(val);
              setShowExitPrompt(val);
            }}
          />
        );
      case 1:
        return (
          <IdeaBank
            setApiLoading={apiLoading}
            show={show || showOnUrl}
            selectedTask={selectedTask}
            handleClose={handleClose}
            selectedColumn={selectedColumn}
            droppableColumn={droppableColumn}
            draggableColumn={draggableColumn}
            board={board}
            updateTask={updateTask}
            handleArchive={handleArchive}
            handleUnarchive={handleUnarchive}
            addTask={addTask}
            config={config}
            handleDelete={handleDelete}
            getColumnNo={getColumnNo}
            columnTitle={
              columnsData?.columnOrder &&
              columnsData?.columnOrder[_index].tasklist_title
            }
            setShowCloseConfirmation={(val) => {
              //setIsBlocking(val);
              setShowExitPrompt(val);
            }}
          />
        );
      case 2:
        return (
          <ActionPlan
            setApiLoading={apiLoading}
            show={show || showOnUrl}
            selectedTask={selectedTask}
            handleClose={handleClose}
            selectedColumn={selectedColumn}
            droppableColumn={droppableColumn}
            draggableColumn={draggableColumn}
            board={board}
            updateTask={updateTask}
            handleArchive={handleArchive}
            handleUnarchive={handleUnarchive}
            addTask={addTask}
            config={config}
            handleDelete={handleDelete}
            getColumnNo={getColumnNo}
            columnTitle={
              columnsData?.columnOrder &&
              columnsData?.columnOrder[_index].tasklist_title
            }
            setShowCloseConfirmation={(val) => {
              //setIsBlocking(val);
              setShowExitPrompt(val);
            }}
          />
        );
      case 3:
        return (
          <Implementation
            setApiLoading={apiLoading}
            show={show || showOnUrl}
            selectedTask={selectedTask}
            handleClose={handleClose}
            selectedColumn={selectedColumn}
            droppableColumn={droppableColumn}
            draggableColumn={draggableColumn}
            board={board}
            updateTask={updateTask}
            handleArchive={handleArchive}
            handleUnarchive={handleUnarchive}
            addTask={addTask}
            config={config}
            handleDelete={handleDelete}
            getColumnNo={getColumnNo}
            columnTitle={
              columnsData?.columnOrder &&
              columnsData?.columnOrder[_index].tasklist_title
            }
            setShowCloseConfirmation={(val) => {
              //setIsBlocking(val);
              setShowExitPrompt(val);
            }}
          />
        );
      case 4:
        return (
          <Evaluation
            setApiLoading={apiLoading}
            show={show || showOnUrl}
            selectedTask={selectedTask}
            handleClose={handleClose}
            selectedColumn={selectedColumn}
            droppableColumn={droppableColumn}
            draggableColumn={draggableColumn}
            board={board}
            updateTask={updateTask}
            handleArchive={handleArchive}
            handleUnarchive={handleUnarchive}
            addTask={addTask}
            config={config}
            handleDelete={handleDelete}
            getColumnNo={getColumnNo}
            columnTitle={
              columnsData?.columnOrder &&
              columnsData?.columnOrder[_index].tasklist_title
            }
            setShowCloseConfirmation={(val) => {
              //setIsBlocking(val);
              setShowExitPrompt(val);
            }}
          />
        );
      default:
        return "";
    }
  };

  const addTask = (columnId, task) => {
    let _columnsData = { ...columnsData };

    let _tasks = _columnsData?.columns[columnId]?.tasks;

    _tasks[task.id] = { ...task };

    let _columnTasks = _columnsData?.columns[columnId]?.taskIds;
    _columnTasks = [task.id, ..._columnTasks];

    _columnsData.columns[columnId].taskIds = [..._columnTasks];

    const newState = {
      ..._columnsData,
      tasks: _tasks,
    };

    setColumnsData(newState);
  };
  const updateTask = (columnId, task) => {
    let _columnsData = { ...columnsData };
    let _tasks = _columnsData?.columns[columnId]?.tasks;

    _tasks[task.id] = { ...task };

    let _column = _columnsData?.columns[columnId];
    if (_column) {
      _column.tasks = { ..._tasks };
    }
    columnsData.columns[columnId] = _column;
    const newState = {
      ..._columnsData,
    };
    setColumnsData(newState);
  };
  const handleArchive = (columnId, task) => {
    let _columnsData = { ...columnsData };

    let _tasksIds = _columnsData?.columns[columnId]?.taskIds.filter(
      (item) => parseInt(item) !== parseInt(task.id)
    );
    let _archived = [
      `${task.id}`,
      ..._columnsData?.columns[columnId]?.archived,
    ];

    let _tasks = _columnsData?.columns[columnId]?.tasks;

    _tasks[task.id] = { ...task };

    let _column = _columnsData?.columns[columnId];
    if (_column) {
      _column.taskIds = _tasksIds;
      _column.archived = _archived;
      _column.tasks = { ..._tasks };
    }

    columnsData.columns[columnId] = _column;
    const newState = {
      ..._columnsData,
    };
    setColumnsData(newState);
  };
  const handleUnarchive = (columnId, task) => {
    let _columnsData = { ...columnsData };

    let _archived = _columnsData?.columns[columnId]?.archived.filter(
      (item) => parseInt(item) !== parseInt(task.id)
    );
    let _tasksIds = [`${task.id}`, ..._columnsData?.columns[columnId]?.taskIds];

    let _tasks = _columnsData?.columns[columnId]?.tasks;

    _tasks[task.id] = { ...task };

    let _column = _columnsData?.columns[columnId];
    if (_column) {
      _column.taskIds = _tasksIds;
      _column.archived = _archived;
      _column.tasks = { ..._tasks };
    }

    columnsData.columns[columnId] = _column;
    const newState = {
      ..._columnsData,
    };
    setColumnsData(newState);
  };
  const openEditModel = (taskToBeEditted) => {
    //    props.history.replace("/foo");
    props.history.replace({
      pathname: `/board/${taskToBeEditted?.board_id}/task/${taskToBeEditted?.id}`,
    });
    history.push(
      `/board/${taskToBeEditted?.board_id}/task/${taskToBeEditted?.id}`
    );
    // console.log("task to be editted: ", taskToBeEditted);
    // document.location = `${document.location.href}/${taskToBeEditted?.id}`;
    handleShow();
    apiRef.current = false;
  };

  const columnOutput = columnsData?.columnOrder?.map((columnId, index) => {
    const column = columnsData.columns[columnId?.id];

    const tasks = column?.taskIds?.map((taskId, index) => {
      return column?.tasks[taskId];
    });

    const archivedTasks = column?.archived?.map((taskId, index) => {
      return column?.tasks[taskId];
    });
    return (
      <div className="task-list p-2 border-end border-1 column" key={index}>
        <Column
          key={column.id}
          columnId={column.id}
          column={column}
          tasks={tasks}
          columnNo={index + 1}
          archivedTasks={archivedTasks}
          board={board}
          addTask={addTask}
          config={config}
          handleDelete={handleDelete}
          getColumnNo={getColumnNo}
          setSelectedTask={setSelectedTask}
          setSelectedColumn={setSelectedColumn}
          openEditModel={openEditModel}
        />
      </div>
    );
  });

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };
  const handleShowConfirmation = () => setShowConfirmation(true);

  const handleDeleteTask = async () => {
    try {
      setLoading(true);

      await dispatch(
        deleteTask(
          selectedTask?.id,
          selectedColumn,
          selectedTask?.post_status,
          selectedTask
        )
      );
      setShowConfirmation(false);
      handleClose();

      setLoading(false);
    } catch (error) {
      console.log({ error });
      setLoading(false);
    }

    handleCloseConfirmation();
  };

  const handleSort = async (taskListId, array, newState) => {
    let _array = [];
    array.forEach((element) => _array.push(parseInt(element)));
    let body = {
      tasklist_id: parseInt(taskListId),
      task_ids: [..._array],
    };
    try {
      dispatch(handleSortTasks({ data: body, state: newState }));
    } catch (error) {
      console.log({ error });
    }
  };
  return (
    <div className="main-wrapper">
      <Helmet>
        <title>{board?.title}</title>
        <meta name="description" content="" />
      </Helmet>
      <Navigation />

      <div className="page-content-wrap">
        <HorizontalNav title={board?.title} />
        <div className="pt-5 pt-lg-0 page-content-inner">
          <div className="col-12">
            <div className="d-flex flex-nowrap overflow-hidden">
              <div className="mw-100 w-100 pt-5 pt-lg-0 tasks-container">
                {loading ? (
                  <div className="container-fluid px-3">
                    <div className="d-flex justify-content-center mt-5">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  </div>
                ) : (
                  <div className="p-0">
                    <div
                      className="d-flex justify-content-between align-items-center bg-white"
                      style={{ minHeight: "40px" }}
                    >
                      <div>
                        <BoardNav className="" board={board} />
                      </div>
                      <div className="px-2 my-1 bottom-navigation">
                        <Button
                          // refresh button main colums
                          onClick={() =>
                            getSingleBoardById(params.board_id, userJwt)
                          }
                          className="text-white rounded tasks-refresh btn-halite-blue-light"
                          size="sm"
                          style={{
                            zIndex: 2,
                          }}
                        >
                          {translation("refresh")}
                        </Button>
                      </div>
                    </div>
                    <div>
                      {boardView === "about" && (
                        <>
                          <div className="col-md-8 col-xs-12 offset-md-2 mt-5 purpose-container">
                            <Purpose
                              purpose={board?.purpose}
                              token={userJwt}
                              boardid={params.board_id}
                              board={board}
                            />
                          </div>
                          <div className="col-md-8 col-xs-12 offset-md-2 shadow bg-white rounded-3 p-4 d-inline-block mb-3 mt-5 notes-container">
                            <BoardNotes
                              userid={userId}
                              token={userJwt}
                              boardid={params.board_id}
                              board={board}
                            />
                          </div>
                        </>
                      )}
                      {boardView === "board" && (
                        <>
                          <div
                            className="w-100"
                            style={{ overflowX: "scroll", minHeight: "65vh" }}
                          >
                            <DragDropContext onDragEnd={handleDragEnd}>
                              <div className="d-flex">{columnOutput}</div>
                            </DragDropContext>
                          </div>
                          {columnsData?.columnOrder?.length > 0 &&
                            addTaskForm(selectedTask)}
                        </>
                      )}

                      {boardView === "guide" && <BoardGuide />}
                      {boardView === "settings" && <BoardSettings board={board} />}
                      {boardView === "chart" && <BoardChart board={board} />}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <ConfirmationBox
            show={showConfirmation}
            handleClose={handleCloseConfirmation}
            title={translation("delete_task")}
            message={`${translation("delete_warning")} ${selectedTask?.title}?`}
            confirmationAction={handleDeleteTask}
            loading={loading}
          />
          <ConfirmationBox
            show={showCloseConfirmationOnTask}
            handleClose={() => setCloseConfirmationOnTask(false)}
            title={translation("confirm_close")}
            message={translation("unsaved_warning")}
            confirmationAction={handleConfirmClose}
            confirmButtonText={translation("leave")}
            closeButtonText={translation("stay")}
          />
        </div>
      </div>
      {/* <Prompt
        when={showExitPrompt}
        message={translation("form_close_confirmation")}
      /> */}
      <RouterPrompt
        when={showExitPrompt}
        onCancel={() => {
          setShowExitPrompt(false);
          setShow(false);
          setShowOnUrl(false);
        }}
      />
    </div>
  );
};

export default Task;
